import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Register ChartJS components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const EmployeesByGenderChart = ({ genders }) => {
  const totalEmployees = genders.reduce((sum, g) => sum + g.count, 0);

  // Colors matching your original implementation
  const barColors = genders.map((g) =>
    g.name.toLowerCase() === "male" ? "#D3001A" : "#ffb500"
  );

  const data = {
    labels: genders.map((g) => g.name),
    datasets: [
      {
        label: "Employees",
        data: genders.map((g) => g.count),
        backgroundColor: barColors,
        borderRadius: 4,
        barPercentage: 0.65,
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const index = elements[0].index;
        const gender = genders[index].name.toLowerCase();
        // Open in a new tab
        window.open(`/employees?gender=${gender}`, '_blank');
      }
    },
    onHover: (event, chartElement) => {
      event.native.target.style.cursor = chartElement.length ? 'pointer' : 'default';
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        mode: 'index',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        bodyFont: {
          size: 12,
        },
        callbacks: {
          title: () => '',
          label: (context) => {
            const value = context.raw;
            const percentage = ((value / totalEmployees) * 100).toFixed(2);
            return `${value} Employees (${percentage}%)`;
          }
        },
      },
      datalabels: {
        color: '#FFFFFF',
        font: {
          // weight: 'bold',
          size: 14,
        },
        formatter: (value) => value,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          drawBorder: false,
        },
      },
    },
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "top",
        padding: "15px",
        width: "100%",
        // height: "320px",
      }}
    >
      {/* <div className="statistic-header">
        <h5 style={{ color: "#555" }}>Gender Distribution</h5>
      </div> */}
      <div style={{ height: "200px", width: "100%" }}>
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default EmployeesByGenderChart;
